import {DateTime} from 'luxon';
import {AgentContext} from '../copilot.types';

type GeneralContext = {
  date: string;
};

function getter(): GeneralContext {
  return {
    date: DateTime.local().toISODate(),
  };
}

function formatter({
  currentContext,
}: {
  prevContext: GeneralContext;
  currentContext: GeneralContext;
}): string {
  return `Current date: ${currentContext.date}`;
}

const generalContext: AgentContext<GeneralContext> = {
  title: 'General Information',
  getter,
  formatter,
};

export default generalContext;
